namespace RioERP.Reports {
    export namespace PermissionKeys {
        export const General = "Reports:General";

        namespace ReportsManagement {
            export const Delete = "Reports:ReportsManagement:Delete";
            export const Modify = "Reports:ReportsManagement:Modify";
            export const View = "Reports:ReportsManagement:View";
        }
    }
}
